import { LoginCredentials } from "store/signin/types";

export const getActiveUser = (): LoginCredentials | null => {
    const activeUser = localStorage.getItem('user');
    return activeUser ? JSON.parse(activeUser) : null;
}